import {
    AnimationComponent,
    Animation,
    Component,
    Object3D,
    MeshComponent,
} from '@wonderlandengine/api';
import {property} from '@wonderlandengine/api/decorators.js';
import {SpecialPower} from '../special-power.js';
import {Puzzle} from '../puzzle.js';
import {Statistics} from '../statistics.js';
import {StatNames} from '../../enums/StatNames.js';
import {BlobPrefabs} from '../blob-prefabs.js';
import {BoardObject} from '../board-object.js';

export enum CoinType {
    Coin,
    Diamond,
    GoldBricks,
}

export class CoinPower extends SpecialPower {
    static TypeName = 'coin-power';
    static InheritProperties = true;

    @property.int(10)
    coinValue = 10;

    @property.enum(Object.keys(CoinType).filter((b) => isNaN(Number(b))))
    coinType: CoinType;

    @property.object({required: true})
    animatedObject!: Object3D;

    @property.animation()
    idle?: Animation;

    @property.string('CoinCollected')
    deathFX = 'CoinCollected';

    private _animation: AnimationComponent;
    private _boardObject: BoardObject;
    start(): void {
        this._animation = this.animatedObject.getComponent(AnimationComponent);

        this._animation.animation = this.idle.retarget([
            this.animatedObject,
            this.animatedObject,
        ]);

        this._animation.play();
    }

    override activate(puzzle: Puzzle, row: number, column: number): void {
        // do not call super, because there's no activation
    }

    override explode(puzzle: Puzzle, row: number, column: number) {
        puzzle.rules.addCoins(this.coinValue, this.object);

        if (this.coinType == CoinType.Coin) {
            Statistics.instance.recordAdditive(StatNames.NumberCoinBlobsPopped, 1);
        } else if (this.coinType == CoinType.Diamond) {
            Statistics.instance.recordAdditive(StatNames.NumberDiamondsCollected, 1);
        } else if (this.coinType == CoinType.GoldBricks) {
            Statistics.instance.recordAdditive(StatNames.NumberGoldBricksCollected, 1);
        }
        // // called when this object explodes on the board.
        if (this.deathFX != null) {
            const fx = BlobPrefabs.instance.spawn(this.deathFX, null, true);
            const p = this._boardObject.object.getPositionWorld();
            const r = this._boardObject.object.getRotationWorld();
            fx.setPositionWorld(p);
            fx.setRotationWorld(r);
        }
        // if (AttachToBaseFX != null)
        // {
        // 	Destroy(AttachToBaseFX);
        // }
        this.object.destroy();
    }

    override loaded(newParent: BoardObject) {
        this._boardObject = newParent;
    }

    override popped(puzzle: Puzzle, row: number, column: number) {
        puzzle.registerForRemoval(row, column);
    }
}
